import { constants as coreConstants } from '@wsb/guac-widget-core';

export const LAYERS = coreConstants.layers;
export const LIMIT = 5;
